// extracted by mini-css-extract-plugin
export default {"headerDropdownLink":"Header_headerDropdownLink__JMBvG"};